import { Form, Modal } from 'antd'
import { FormInstance } from 'antd/lib/form'
import * as React from 'react'

import { IRaccoltaDatiService } from '../../services/RaccoltaDatiService'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'

import { Saldo } from '../../models/RaccoltaDatiModels'

import { TTFormItem } from '../shared/TTFormItem'
import { TTInputCurrency } from '../shared/TTInputCurrency'
import { TTModalProps } from '../shared/TTModalProps'

interface ModalSaldoProps extends TTModalProps {
    data: Saldo
}

export class ModalSaldo extends React.Component<ModalSaldoProps, any> {

    service: IRaccoltaDatiService
    formRef = React.createRef<FormInstance>()
    saldoRef = React.createRef<HTMLInputElement>()

    constructor(props) {
        super(props)

        this.service = container.get(SERVICE_IDENTIFIER.RACCOLTA_DATI_SERVICE)
    }

    componentDidMount() {
        this.saldoRef.current.focus()
    }

    closeModal = () => {
        this.formRef.current.resetFields()
        this.props.closeModal()
    }

    onSave = async () => {
        try {
            let data = await this.formRef.current.validateFields()
            let saldo = data["Saldo"]
            let model = { ...this.props.data }
            model.Saldo = saldo

            let resp = await this.service.SaveSaldo(model)
            if (resp.IsValid == true) {
                this.props.do()
                this.props.closeModal()
            }

        } catch (err) {
            console.log(err)
        }
    }

    render() {
        return (
            <Modal
                title="Modifica saldo conto corrente"
                visible={this.props.visible}
                onCancel={() => this.closeModal()}
                onOk={this.onSave}>
                <Form ref={this.formRef}>
                    <TTFormItem label="Conto Corrente">{this.props.data.ContoCorrente}</TTFormItem>
                    <TTFormItem name="Saldo" label="Saldo" initialValue={this.props.data.Saldo} rules={[
                        { required: true }
                    ]}>
                        <TTInputCurrency style={{ width: '80%' }} ref={this.saldoRef} onPressEnter={this.onSave} />
                    </TTFormItem>
                </Form>
            </Modal>
        )
    }
}